module.exports = __webpack_public_path__ + "assets/img/quesheng.9784f1d6.png";